import { Form, Input } from 'antd'
import { useTranslation } from 'react-i18next'

import { usePropertyInsuranceValues } from './PropertyInsuranceContext'
import { formProps } from './utils'

export const Franchise = () => {
  const { t } = useTranslation()
  const { franchiseProps } = formProps(t)
  const { isEditable } = usePropertyInsuranceValues()

  return (
    <Form.Item {...franchiseProps}>
      <Input.TextArea
        placeholder={franchiseProps.label}
        disabled={isEditable}
        autoSize
      />
    </Form.Item>
  )
}
